// extracted by mini-css-extract-plugin
export default {"zoomModal":"j5-z"};